import { BarChart3 } from 'lucide-react';

type CampaignPerformanceGraphButtonProps = {
  campaignName: string;
  onClick: () => void;
};

export function CampaignPerformanceGraphButton({
  campaignName,
  onClick,
}: CampaignPerformanceGraphButtonProps) {
  return (
    <button
      type="button"
      className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-md border border-[#c9d7e6] bg-[#eef3f8] text-[#2c455d] hover:bg-[#e3ebf3] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-brand"
      aria-label={`View campaign performance for ${campaignName}`}
      title="View campaign performance"
      onClick={(event) => {
        event.stopPropagation();
        event.preventDefault();
        onClick();
      }}
    >
      <BarChart3 className="h-3.5 w-3.5" aria-hidden />
    </button>
  );
}
